import type { FaireProductEntity } from "../../entity_types/product";

export const p_bdfqunzkez: FaireProductEntity = {
  token: "p_bdfqunzkez",
  type: "product",
  name: "One Carnelian Butterfly",
  brandToken: "b_pqhb98yzxr",
  brandName: "Mi Esperanza Minerals",
  imageUrl:
    "https://cdn.faire.com/fastly/e2eea19941bfd2edc3ab7dee63193d135753479a716a557aafe5393ce5a99088.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed92cc6468d44b2d50d937f98602bf4d6cd658646cd25c72c45164173a759bcf.jpeg",
    "https://cdn.faire.com/fastly/ba11702e4a2b35cac2621244a5f04a6bfc0e14dc9783e720edf077717da2f139.jpeg",
    "https://cdn.faire.com/fastly/91e1cc5cb288cf35e2f4a88b8c252882a15c461e17b0bd42208db97ae0b1ba1f.jpeg",
    "https://cdn.faire.com/fastly/49c17c41026f3dc8d5b037a4a4e555ec9a050fe71c0c5d8b8bbc16dc20e53047.jpeg",
    "https://cdn.faire.com/fastly/3c2d35e3fbd7f6b1b06ce5f407b0ee90565fa16175dad1ed9ea62f045ee8a6d0.jpeg",
    "https://cdn.faire.com/fastly/1d843d76fb730859e14e2697363303ba740cdf7b56ef748983e499d53100aa6d.jpeg",
    "https://cdn.faire.com/fastly/702baecba869d280774b009e1446560c07a3659c087582db7e4d6e808d829892.jpeg",
    "https://cdn.faire.com/fastly/0ef1a697926e9c5d264a42f12b800df7a788047aa7c06cfecc0fcbadab0a5025.jpeg",
  ],
  priceDollars: 19.4,
  description:
    'You will receive 1 Carnelian Butterfly approximately the same size and quality as the ones pictured. Note that patterns, colors, shapes, veins, and shades may vary. (All props shown in the photo are not included, they are only present for display purposes only. You will only receive 1 Butterfly)\n\nPieces measure approximately between 2.38" x 2" and 2.50" x 2.13".\n',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:38.227Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
